// extracted by mini-css-extract-plugin
export default {"badge":"FoundingTesterBadge_badge__2VVvz","art":"FoundingTesterBadge_art__1ejCw","label":"FoundingTesterBadge_label__x30JX","tip":"FoundingTesterBadge_tip__vrCd9"};